import { Outlet } from 'react-router';
import { Loader } from '@f2m3/shared-frontend-ui';
import type { AccountRole } from '../../api/types';
import { useLogin } from '../../hooks/useLogin';
import Forbidden, { type ForbiddenRequired } from '../../pages/admin/Forbidden';

/**
 * Builds a pathless layout route for /admin that admits one role set and
 * renders Forbidden (with copy naming that set) to everyone else, deep links
 * included. AdminRoute above it has already admitted a STAFF user; these
 * guards narrow that to a feature's own set (AdminOnlyRoute, SalesStaffRoute,
 * RetouchStaffRoute). Each caller is a distinct component, so route-config
 * tests can still identify a guard by element type.
 */
export const createRoleRoute = (
  displayName: string,
  allow: (roles: readonly AccountRole[] | undefined | null) => boolean,
  required: ForbiddenRequired,
) => {
  const RoleRoute = () => {
    const { userData, isPending } = useLogin();
    if (isPending) return <Loader />;
    if (!allow(userData?.roles)) return <Forbidden required={required} />;
    return <Outlet />;
  };
  RoleRoute.displayName = displayName;
  return RoleRoute;
};
